import React, { useContext, useEffect, useState } from 'react';
import { MetricEntityType, MetricFilter } from '../../../../types/metrics/metricFilter';
import { DashboardQueries, MetricsResponse, MetricsVariables } from '../../../../graphql/dashboard.graphql';
import MetricResult, { MetricResultType } from '../../../../types/metrics/metricResult';
import { useQuery } from '@apollo/client';
import ChartNumber from '../../Charts/ChartNumber';
import { Dashboard, DashboardContext } from '../../../../context/DashboardContext';

interface MetricChartNumberProps {
  filter: MetricFilter;
  type: MetricEntityType;
  title: string;
}

export default function MetricChartNumber({ filter, title, type }: MetricChartNumberProps) {
  const { cache, setCache } = useContext(DashboardContext);

  const [data, setData] = useState<number>(0);

  const locale = (window.navigator as any)['userLanguage'] || window.navigator.language;

  const cacheKey = Dashboard.getCacheKey(type, filter);
  const hasCachedData = cache.has(cacheKey);

  const { loading, refetch } = useQuery<MetricsResponse, MetricsVariables>(DashboardQueries.metrics, {
    variables: { filter, type },
    skip: hasCachedData,
    onCompleted: data => {
      cache.set(cacheKey, { data: data.metrics, type: MetricResultType.type });
      setCache(new Map(cache));

      setData(MetricResult.toChartNumberData(data.metrics, filter.interval, locale));
    },
  });

  useEffect(() => {
    if (hasCachedData && cache.has(cacheKey)) {
      const { data: cachedData } = cache.get(cacheKey)!;
      const value = MetricResult.toChartNumberData(cachedData, filter.interval, locale);
      setData(value);
    }
  }, [cache, filter]);

  return <ChartNumber loading={loading} title={title} text={data.toString()} />;
}
